import BarChart from './BarChart';

export default BarChart;
export * from './BarChart';
